module.exports = {
  foo () { console.log('foo') },
  bar () { console.log('bar') },
	downloadCSVFile(csv, filename) {
		var csv_file, download_link;

		csv_file = new Blob([csv], {type: "text/csv"});

		download_link = document.createElement("a");

		download_link.download = filename;

		download_link.href = window.URL.createObjectURL(csv_file);

		download_link.style.display = "none";

		document.body.appendChild(download_link);

		download_link.click();
	},
	htmlToCSV(tableID, filename) {
		var selectedTable = document.getElementById(tableID);
		var data = [];
		var rows = selectedTable.rows;
				
		for (var i = 0; i < rows.length; i++) {
			var row = [], cols = rows[i].querySelectorAll("td, th");
					
			for (var j = 0; j < cols.length; j++) {
					row.push(cols[j].innerText);
			}
					
			data.push(row.join(",")); 		
		}
		let csv = data.join("\n");
		
		var csv_file, download_link;

		csv_file = new Blob([csv], {type: "text/csv"});

		download_link = document.createElement("a");

		download_link.download = filename;

		download_link.href = window.URL.createObjectURL(csv_file);

		download_link.style.display = "none";

		document.body.appendChild(download_link);

		download_link.click();
		
	},
	exportTableToTSV(tableID, filename = ''){
		
		var downloadLink;
		var dataType = 'application/vnd.ms-excel';
		var tableSelect = document.getElementById(tableID);
		console.log(tableSelect);
		var csvContent = "data:text;charset=utf-8,";
		tableSelect.rows.forEach(function(rowArray){
			console.log(rowArray);
			csvContent += rowArray.join("\t") + "\n";
		});
		var tableHTML = csvContent;
		/*
		var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

		// Specify file name
		filename = filename?filename+'.xls':'excel_data.xls';
		*/
		// Create download link element
		downloadLink = document.createElement("a");

		document.body.appendChild(downloadLink);
		
		if(navigator.msSaveOrOpenBlob){
		var blob = new Blob(['\ufeff', tableHTML], {
		type: dataType
		});
		navigator.msSaveOrOpenBlob( blob, filename);
		}else{
		// Create a link to the file
		downloadLink.href = tableHTML;

		// Setting the file name
		downloadLink.download = "result.tsv";

		//triggering the function
		downloadLink.click();
		}
	},
  
  /*
	exportTableToExcel(tableID, filename = ''){
		var downloadLink;
		var dataType = 'application/vnd.ms-excel';
		var tableSelect = document.getElementById(tableID);
		var csvContent = "data:text;charset=utf-8,";
		
		var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

		// Specify file name
		/*
		filename = filename?filename+'.xls':'excel_data.xls';
		*/
		// Create download link element
		/*
		downloadLink = document.createElement("a");

		document.body.appendChild(downloadLink);
		
		if(navigator.msSaveOrOpenBlob){
		var blob = new Blob(['\ufeff', tableHTML], {
		type: dataType
		});
		navigator.msSaveOrOpenBlob( blob, filename);
		}else{
		// Create a link to the file
		downloadLink.href = tableHTML;

		// Setting the file name
		downloadLink.download = "result.tsv";

		//triggering the function
		downloadLink.click();
		}
		*/
	//},
}


//export default mylib
